import { useMemo } from 'react';
import { cn } from '@reflex/ui/lib/utils';
import { LogEmptyState } from './LogEmptyState';

export function PlainViewer({ lines, filter }: { lines: string[]; filter: string }) {
  const filtered = useMemo(() => {
    if (!filter) return lines;
    const lower = filter.toLowerCase();
    return lines.filter((l) => l.toLowerCase().includes(lower));
  }, [lines, filter]);

  return (
    <div className="font-mono text-2xs leading-[1.6]">
      {filtered.map((line, i) => {
        const lower = line.toLowerCase();
        const isError = lower.includes('error') || lower.includes('fatal');
        const isWarn = lower.includes('warn');
        return (
          <div
            key={i}
            className={cn(
              'flex gap-0 border-l-2 px-2 py-px hover:bg-foreground/2 transition-colors',
              isError
                ? 'border-l-status-error/50 bg-status-error/5'
                : isWarn
                  ? 'border-l-status-warning/40 bg-status-warning/5'
                  : 'border-l-transparent',
            )}
          >
            <span className="text-muted-foreground w-6 text-right shrink-0 select-none mr-3">
              {i + 1}
            </span>
            <span
              className={cn(
                'break-all',
                isError
                  ? 'text-status-error'
                  : isWarn
                    ? 'text-status-warning'
                    : 'text-foreground/80',
              )}
            >
              {line}
            </span>
          </div>
        );
      })}
      {filtered.length === 0 && <LogEmptyState>No matching lines</LogEmptyState>}
    </div>
  );
}
